import { ValuableNode } from '../../models/ValuableNode'

export class SchemaTypedSchemaNode extends ValuableNode {}

declare global {
  export interface RehajeTypedNodes {
    'Schema.TypedSchema': SchemaTypedSchemaNode
  }
}
